<div class="row">
  <ng-container *ngFor="let rec of cards" >
    <div *ngIf="rec.status && !rec.header && !rec.noCard" (click)="goto(rec.route)" class="col s12 m3" style="cursor:pointer">
      <div class="card border-radius-3 {{rec.cssCard}}">
        <div class="card-content center">
          <i class="material-icons background-round mt-5 mb-5 white-text">{{rec.icon}}</i>
          <!-- <h5 class="icon-background circle white-text z-depth-3 {{rec.cssIcon}}" style="display:inline-block;"><i class="material-icons">{{rec.icon}}</i></h5> -->
              
              <h5 class="white-text lighten-4">{{rec.title}}</h5>
              <p class="white-text lighten-4">{{rec.title2}}</p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="row hide">
  <div class="col s12 m3">
    <div class="card gradient-shadow gradient-45deg-light-blue-cyan border-radius-3">
      <div class="card-content center">
        <h5 class="icon-background circle white-text z-depth-3 gradient-45deg-red-pink" style="display:inline-block;"><i class="material-icons">equalizer</i></h5>
            
            <h5 class="white-text lighten-4">DASHBOARD</h5>
            <p class="white-text lighten-4">On apple watch</p>
      </div>
    </div>
  </div>
  <div class="col s12 m3">
    <div class="card red border-radius-3">
      <div class="card-content center">
        <h5 class="icon-background circle white-text z-depth-3 gradient-45deg-red-pink" style="display:inline-block;"><i class="material-icons">equalizer</i></h5>
            
            <h5 class="white-text lighten-4">DASHBOARD</h5>
            <p class="white-text lighten-4">On apple watch</p>
      </div>
    </div>
  </div>
  <div class="col s12 m3">
    <div class="card blue-grey darken-4 border-radius-3">
      <div class="card-content center">
        <h5 class="icon-background circle white-text z-depth-3 gradient-45deg-red-pink" style="display:inline-block;"><i class="material-icons">equalizer</i></h5>
            
            <h5 class="white-text lighten-4">DASHBOARD</h5>
            <p class="white-text lighten-4">On apple watch</p>
      </div>
    </div>
  </div>
</div>